// extracted by mini-css-extract-plugin
export default {"car_price__full":"CarPrice-module__car_price__full--Nur7S","car_price__month":"CarPrice-module__car_price__month--Tr6nh"};